module.exports = __webpack_public_path__ + "img/kong.33c13adc.jpg";